import { createSingleBeneficiary } from '@api/beneficiaries';
import { Button, Dropdown, FormInput, Modal } from '@basqet-dashboard/common/components';
import { useCurrencies } from '@basqet-dashboard/common/hooks';
import { formatErrorMessage, singleBeneficiarySchema } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const SingleBeneficiaryModal = ({ onModalClose, beneficiary_info }) => {
  const { cryptoCurrencies } = useCurrencies();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting, isValid, isDirty }
  } = useForm({
    mode: 'onChange',
    defaultValues: { ...beneficiary_info },
    resolver: yupResolver(singleBeneficiarySchema)
  });

  const onSubmit = async (data) => {
    try {
      await createSingleBeneficiary(data);
      await toast.success('Single Beneficiary created');
      await reset();
      onModalClose();
    } catch (error) {
      formatErrorMessage(error);
    }
  };

  return (
    <Modal header={{ name: 'Add', cursive: 'Single Beneficiary' }} onModalClose={onModalClose}>
      <div className="modal__form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormInput
            label="Beneficiary wallet address"
            placeholder="Kindly enter beneficiary's wallet address"
            defaultValue={beneficiary_info?.wallet_address}
            readOnly={Boolean(beneficiary_info?.wallet_address)}
            error={errors.wallet_address && errors.wallet_address.message}
            register={register('wallet_address')}
          />
          <FormInput
            label="Beneficiary Alias"
            placeholder="Kindly enter an alias for the beneficiary"
            error={errors.alias && errors.alias.message}
            register={register('alias')}
          />
          <Dropdown
            formLabel="Currency"
            options={cryptoCurrencies}
            name="currency_id"
            register={register('currency_id')}
            defaultValue={+beneficiary_info?.currency_id}
            readOnly={Boolean(beneficiary_info?.currency_id)}
            placeholder="Kindly select Currency"
            error={errors.currency && errors.currency.message}
          />

          <Button disabled={!isDirty || !isValid} isLoading={isSubmitting} isFull>
            Save Beneficiary
          </Button>
        </form>
      </div>
    </Modal>
  );
};

SingleBeneficiaryModal.propTypes = {
  onModalClose: PropTypes.func,
  beneficiary_info: PropTypes.object
};
export { SingleBeneficiaryModal };
